import React from 'react';

interface ScrollAreaProps {
  children: React.ReactNode;
  className?: string;
  maxHeight?: string;
}

const ScrollArea: React.FC<ScrollAreaProps> = ({ 
  children, 
  className = '',
  maxHeight = '200px'
}) => {
  return (
    <div 
      className={`
        ${className}
        overflow-y-auto
        scrollbar-hide
        scroll-smooth
        relative
      `}
      style={{ maxHeight }}
    >
      {children}
    </div>
  );
};

export default ScrollArea;
